/*
 * The shop policies (/policies/*), made readable — WITHOUT CHANGING A WORD (2026-10-06).
 *
 * William: "we need preserve exactly the text, just show it better and totally clear". The policy
 * bodies are Shopify's, published from the app (Communications → Policies); this script only
 * arranges what is already on the page:
 *
 *   1. LINKS THAT LEFT THE SITE come home. The privacy notice is a Termly export whose 23 internal
 *      links point at an old copy of the same notice on the Wix file host
 *      (www-swrfmarket-com.filesusr.com/html/…#infocollect) — a bare HTML page off the site. A link
 *      to a section that exists on THIS page is pointed at it (`#infocollect`). Only the href
 *      changes; the link's words do not.
 *   2. A CONTENTS LIST beside the text (desktop), sticky, marking the section being read; on a
 *      phone a dropdown at the top. Its entries are the policy's OWN table of contents, word for
 *      word — or, for a policy without one, its own headings.
 *   3. Each section's heading becomes a clear band with "↑ Contents".
 *
 * Nothing is moved: the Termly markup nests unevenly (a section's anchor sits 4 to 23 levels
 * deep), so wrapping sections in boxes would mean re-parenting the legal text. Bands on the
 * headings give the same separation and touch nothing else. Without this script the page reads
 * exactly as before.
 */
(function () {
  var body = document.querySelector('.shopify-policy__body');
  var container = document.querySelector('.shopify-policy__container');
  if (!body || !container || container.classList.contains('swrp')) return;

  var byId = function (id) {
    try { return body.querySelector('[id="' + id.replace(/"/g, '\\"') + '"]'); } catch (e) { return null; }
  };

  // 1 · links into this document, wherever they were written to point
  body.querySelectorAll('a[href*="#"]').forEach(function (a) {
    var href = a.getAttribute('href') || '';
    var id = decodeURIComponent(href.slice(href.indexOf('#') + 1));
    if (!id || !byId(id)) return;
    var url;
    try { url = new URL(href, location.href); } catch (e) { return; }
    var samePage = url.host === location.host && url.pathname === location.pathname;
    var oldCopy = /(^|\.)filesusr\.com$/.test(url.host);
    if (samePage || oldCopy) {
      a.setAttribute('href', '#' + id);
      a.removeAttribute('target');
    }
  });

  // 2 · the sections: the policy's own contents list, else its headings
  var sections = [];
  var toc = byId('toc');
  if (toc && toc.parentElement) {
    var seen = {};
    toc.parentElement.querySelectorAll('a[href^="#"]').forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var el = byId(id);
      if (!el || seen[id] || id === 'toc') return;
      seen[id] = 1;
      sections.push({ id: id, el: el, label: a.textContent.replace(/\s+/g, ' ').trim() });
    });
  }
  if (sections.length < 3) {
    sections = [];
    var hs = body.querySelectorAll('h2');
    if (hs.length < 3) hs = body.querySelectorAll('h3');
    hs.forEach(function (h, i) {
      if (!h.id) h.id = 'section-' + (i + 1);
      sections.push({ id: h.id, el: h, label: h.textContent.replace(/\s+/g, ' ').trim() });
    });
  }
  if (sections.length < 3) return;

  container.classList.add('swrp');

  // The contents: a list beside the text, a dropdown on a phone.
  var nav = document.createElement('nav');
  nav.className = 'swrp-toc';
  nav.id = 'swrp-contents';
  nav.setAttribute('aria-label', 'Contents');
  var el = function (tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  nav.appendChild(el('div', 'swrp-toc__title', 'Contents'));
  var list = el('ol', 'swrp-toc__list');
  var pick = el('label', 'swrp-toc__select');
  pick.appendChild(el('span', 'visually-hidden', 'Go to a section'));
  var select = el('select');
  var none = el('option', null, 'Go to a section\u2026');
  none.value = '';
  select.appendChild(none);
  sections.forEach(function (s) {
    var li = el('li');
    var a = el('a', null, s.label);
    a.href = '#' + s.id;
    a.setAttribute('data-id', s.id);
    li.appendChild(a);
    list.appendChild(li);
    var o = el('option', null, s.label);
    o.value = s.id;
    select.appendChild(o);
  });
  pick.appendChild(select);
  nav.appendChild(list);
  nav.appendChild(pick);
  container.insertBefore(nav, body);

  select.addEventListener('change', function () {
    var s = sections.filter(function (x) { return x.id === select.value; })[0];
    if (s) { s.el.scrollIntoView({ block: 'start' }); history.replaceState(null, '', '#' + s.id); }
  });

  // 3 · each section's heading is a band, with a way back to the contents
  sections.forEach(function (s) {
    s.el.classList.add('swrp-h');
    var back = document.createElement('a');
    back.className = 'swrp-back';
    back.href = '#swrp-contents';
    back.textContent = '↑ Contents';
    s.el.appendChild(back);
  });
  // Every other anchor in the text (the notice's sub-sections) lands below the sticky header too.
  body.querySelectorAll('[id]').forEach(function (el) { el.classList.add('swrp-anchor'); });

  // Where the reader is: the last section whose heading has passed the top third of the screen.
  var links = nav.querySelectorAll('.swrp-toc__list a');
  function mark() {
    var line = window.innerHeight * 0.3;
    var current = null;
    sections.forEach(function (s) { if (s.el.getBoundingClientRect().top <= line) current = s.id; });
    links.forEach(function (a) { a.classList.toggle('is-current', a.getAttribute('data-id') === current); });
    if (select.value !== (current || '')) select.value = current || '';
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; mark(); });
  }, { passive: true });
  mark();
})();
